import Dashboard from './index.vue'
export default Dashboard
